<form [formGroup]="fieldAssignmentEditForm()">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="ic-targetName" class="control-label required">{{
        'i18n.domain.import-configuration.edit.file.shared.edit.target-field' | translate }}</label>
      <input id="ic-targetName" type="text" class="form-control" formControlName="targetName" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.targetName"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!targetDefinition()?.canHaveFixValue || isStaticFunctionUsed()">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.shared.edit.set-value' |
        translate}}</label>
      <div class='e-btn-group'>
        <input type="radio" id="1" [ngModel]="useImportColumn()" [value]="true" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onUseImportColumnChange($event)">
        <label class="e-btn d-flex align-items-center"
          for="1">{{'i18n.domain.import-configuration.edit.file.shared.edit.use-import-column' | translate}}</label>
        <input type="radio" id="2" [ngModel]="useImportColumn()" [value]="false" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onUseImportColumnChange($event)">
        <label class="e-btn d-flex align-items-center"
          for="2">{{'i18n.domain.import-configuration.edit.file.shared.edit.use-fix-value' | translate}}</label>
      </div>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6" [hidden]="!useImportColumn()">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.shared.edit.function' |
        translate}}</label>
      <ejs-dropdownlist [dataSource]="targetDefinition()?.supportedFunctions" [fields]="enumDropdownSettings"
        id="ic-importFunction" formControlName="importFunction">
        <ng-template #itemTemplate let-data>
          {{ImportFunction[data]}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{ImportFunction[data]}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="fieldAssignmentEditForm().controls.importFunction"></app-error-messages>
    </div>
    @if(isColumnBased()){
      <div class="form-group col-md-6" [hidden]="(!useImportColumn() && targetDefinition()?.canHaveFixValue) || isStaticFunctionUsed()">
        <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.shared.edit.import-column' |
          translate}}</label>
        <ejs-dropdownlist [dataSource]="possibleSources()" [fields]="availableSourcesDropdownSettings"
          id="ic-sourceElementName" [value]="selectedSourceFieldId()" (valueChange)="onSourceFieldSelected($event)"
          (close)="onSourceFieldDropdownClosed()">
          <ng-template #itemTemplate let-data>
            {{getColumnDisplayName(data)}}
          </ng-template>
          <ng-template #valueTemplate let-data>
            <div class="centered">
              <span>{{data?.sourceElementName}}</span>
            </div>
          </ng-template>
        </ejs-dropdownlist>
        <app-error-messages [control]="fieldAssignmentEditForm().controls.sourceElementName"></app-error-messages>
      </div>
    }
    @if(!isColumnBased()){
      <div class="form-group col-md-6" [hidden]="(!useImportColumn() && targetDefinition()?.canHaveFixValue) || isStaticFunctionUsed()">
        <label for="ic-sourceElementName" class="control-label required">{{
          'i18n.domain.import-configuration.edit.file.shared.edit.import-column' | translate }}</label>
        <input id="ic-sourceElementName" type="text" class="form-control" formControlName="sourceElementName" />
        <app-error-messages [control]="fieldAssignmentEditForm().controls.sourceElementName"></app-error-messages>
      </div>
    }
    <div class="form-group col-md-6"
      [hidden]="!targetDefinition()?.canHaveFixValue || useImportColumn() || isStaticFunctionUsed()">
      <label for="ic-fixValue" class="control-label required">{{
        'i18n.domain.import-configuration.edit.file.shared.edit.fix-value' | translate }}</label>
      <input id="ic-fixValue" type="text" class="form-control" formControlName="fixValue" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.fixValue"></app-error-messages>
    </div>
    <!-- We hide the isGrouping field as currently it is not used in the application -->
    <!-- <div class="form-group col-md-6" [hidden]="isStaticFunctionUsed() || !useImportColumn()"> -->
    <div class="form-group col-md-6" [hidden]="true">
      <label class="control-label required">{{
        'i18n.domain.import-configuration.edit.file.shared.edit.is-grouping-element' | translate }}</label>
      <app-yes-no-group-button id="ic-isGroupingElement" formControlName="isGroupingElement"></app-yes-no-group-button>
    </div>
  </div>
  <!-- We hide the set value as null and cap fields as currently they are not used in the application -->
  <!-- <div class="form-row row">
    <div class="form-group col-md-6"
      [hidden]="!targetDefinition().canHaveSetNullValue || isStaticFunctionUsed() || !useImportColumn()">
      <label class="control-label">{{ 'i18n.domain.import-configuration.edit.file.shared.edit.set-null-values' |
        translate }}</label>
      <app-yes-no-group-button id="setValueAsNull" formControlName="setValueAsNull"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6"
      [hidden]="!targetDefinition().canHaveCap || isStaticFunctionUsed() || !useImportColumn()">
      <label for="cap" class="control-label">{{ 'i18n.domain.import-configuration.edit.file.shared.edit.cap' |
        translate }}</label>
      <input id="cap" type="text" class="form-control" formControlName="cap" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.cap"></app-error-messages>
    </div>
  </div> -->
  <div class="form-row row" [hidden]="isStaticFunctionUsed() || !useImportColumn()">
    <div class="form-group col-12">
      <label for="ic-document-path" class="control-label">{{
        'i18n.domain.import-configuration.edit.file.shared.edit.document-path' | translate }}</label>
      <input id="ic-document-path" type="text" class="form-control" formControlName="sourceElementSelectionPath" />
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6" [hidden]="!functionDefinition()?.parameter1">
      <label for="ic-functionParameter1Value" class="control-label"
        [ngClass]="{'required': functionDefinition()?.parameter1?.isMandatory}">{{functionDefinition()?.parameter1?.name}}</label>
      <input id="ic-functionParameter1Value" type="text" class="form-control" formControlName="functionParameter1Value" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.functionParameter1Value"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!functionDefinition()?.parameter2">
      <label for="ic-functionParameter2Value" class="control-label"
        [ngClass]="{'required': functionDefinition()?.parameter2?.isMandatory}">{{functionDefinition()?.parameter2?.name}}</label>
      <input id="ic-functionParameter2Value" type="text" class="form-control" formControlName="functionParameter2Value" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.functionParameter2Value"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!functionDefinition()?.parameter3">
      <label for="ic-functionParameter3Value" class="control-label"
        [ngClass]="{'required': functionDefinition()?.parameter3?.isMandatory}">{{functionDefinition()?.parameter3?.name}}</label>
      <input id="ic-functionParameter3Value" type="text" class="form-control" formControlName="functionParameter3Value" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.functionParameter3Value"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!functionDefinition()?.parameter4">
      <label for="ic-functionParameter4Value" class="control-label"
        [ngClass]="{'required': functionDefinition()?.parameter4?.isMandatory}">{{functionDefinition()?.parameter4?.name}}</label>
      <input id="ic-functionParameter4Value" type="text" class="form-control" formControlName="functionParameter4Value" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.functionParameter4Value"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!functionDefinition()?.parameter5">
      <label for="ic-functionParameter5Value" class="control-label"
        [ngClass]="{'required': functionDefinition()?.parameter5?.isMandatory}">{{functionDefinition()?.parameter5?.name}}</label>
      <input id="ic-functionParameter5Value" type="text" class="form-control" formControlName="functionParameter5Value" />
      <app-error-messages [control]="fieldAssignmentEditForm().controls.functionParameter5Value"></app-error-messages>
    </div>
  </div>
</form>
